import { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { useMemo } from 'react';

export const hasStrings = (l: RefinementListItem[]) => l.some((item) => isNaN(item.label));

const sortNumberItems = (a: RefinementListItem, b: RefinementListItem) => {
  return parseFloat(a.label) - parseFloat(b.label);
};

function availabilityFilterValues(items: RefinementListItem[]) {
  return [
    ...items.filter((item: RefinementListItem) => item.label === 'in-stock'),
    ...items.filter((item: RefinementListItem) => item.label.match(/^\d+(\.\.\d*)?$/)).sort(sortNumberItems),
  ];
}

export const useSortedItems = (items: RefinementListItem[], filter: string) => {
  return useMemo(() => {
    if (items.length === 0) {
      return [];
    }

    if (filter === 'availability') {
      return availabilityFilterValues(items);
    }

    if (!hasStrings(items)) {
      return items.sort(sortNumberItems);
    }

    return items;
  }, [items]);
};
